import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
import { getNpcComponent } from "../../utils/openAI-utils";
import { ReactComponent as RecordIcon } from "../icons/recording.svg";
import styles from "./AudioRecordingAI.scss";
import { getAIEntity } from "../../utils/openAI-utils";
import { PrivateChatContext } from "../chat/PrivateChatContext";
import { useVolumeMeter } from "../misc/useVolumeMeter";
import { useMicrophoneStatus } from "./useMicrophoneStatus";
import { PermissionStatus } from "../../utils/media-devices-utils";
import { useVAD } from "../chat/AIChatContext";
import { Button } from "@fluentui/react-components";

import { MicFilled, DismissFilled, MicOffFilled } from "@fluentui/react-icons";
// import { useVoskMicrophone } from "./hooks/vosk/useMicrophoneVosk";
import voskManager from "../../singleton/VoskHandlerManager";
import aiAgents from "../../singleton/AIAgents";

export function AudioRecorderUser({
  textMode,
  receiver,
  scene,
  onListening,
  onTalking,
  talking,
  swapToKeyboard,
  mySessionId,
  toggleMicActive,
  micActive,
  loadingSpeech
}) {
  const [recording, setRecording] = useState(false);

  const { getAILastMessage } = useContext(PrivateChatContext);
  const [currentNPC, setCurrentNPC] = useState(null);

  const receiverRef = useRef(null);

  const talkingRef = useRef(talking);
  const thinkingRef = useRef(loadingSpeech);
  const currentNPCRef = useRef(currentNPC);
  const micActiveRef = useRef(micActive); // Create a ref to store the latest micActive

  useEffect(() => {
    micActiveRef.current = micActive;
  }, [micActive]);

  useEffect(() => {
    thinkingRef.current = loadingSpeech;
  }, [loadingSpeech, thinkingRef]);

  const onSpeechEndCallback = useCallback(
    async e => {
      const audioBuffer = e.detail;
      const agent = aiAgents.getAgentById(receiverRef.current);
      const aiEntity = agent.el;
      const npcComponent = getNpcComponent(aiEntity);

      if (talkingRef.current) {
        return;
      }

      // if(thinkingRef.current) {
      //
      //   return;
      // }

      if (!document.hasFocus()) {
        return;
      }

      if (textMode || !micActiveRef.current) return;

      aiAgents.dispatchThinkingAI(agent);
      // await delayRecognizitionResult();
      // endRecognition();
      // const copiedUtterances = JSON.parse(JSON.stringify(utterancesRef.current));
      // const promptTranscribed = voskManager.getPromptCleaned(copiedUtterances);
      //

      const promptTranscribed = await aiAgents.getOpenAITranscriptionByAudio(audioBuffer, true, agent.objectUuid);

      if (!promptTranscribed) {
        aiAgents.dispatchFinishThinkingAI();
        aiAgents.handleErrorTranscription(agent);
        return;
      }

      if (textMode || !micActiveRef.current) return;

      //1. Send my speech to audio
      aiAgents.setMyLocalMessageTranscribed({
        messageTranscribed: promptTranscribed,
        receiver: receiverRef.current,
        mySessionId: mySessionId
      });

      // setTimeout(() => {
      //   setUtterances([]);
      // }, 60);

      if (!promptTranscribed) {
        npcComponent.isTalking = false;
        aiAgents.dispatchFinishThinkingAI();
        // npcComponent.errorRecording();
        return;
      }
      // aiAgents.dispatchThinkingAI(agent);
      aiAgents.setAILoadingMessage(receiverRef.current);
      await new Promise(resolve => setTimeout(resolve, 10));
      const AILastMessage = getAILastMessage(receiver);

      //2. Send Prompt
      await aiAgents.sendPrompt({
        agent,
        message: promptTranscribed,
        intention: "text",
        enableSpeech: true,
        messageId: AILastMessage.id
      });

      // aiAgents.dispatchFinishThinkingAI();
      // onLoadingImage(false);
    },
    [getAILastMessage, mySessionId, receiver, textMode]
  );

  const { isRecording, startRecording } = useVAD();

  const onSpeechStartCallback = useCallback(() => {
    if (!talkingRef.current && micActiveRef.current && !thinkingRef.current) {
      startRecording();
    }
  }, [startRecording]);

  useEffect(() => {
    window.addEventListener("ai-recording-start", onSpeechStartCallback);
    window.addEventListener("ai-recording-end", onSpeechEndCallback);

    return () => {
      window.removeEventListener("ai-recording-start", onSpeechStartCallback);
      window.removeEventListener("ai-recording-end", onSpeechEndCallback);
    };
  }, [onSpeechEndCallback, onSpeechStartCallback, receiver]);

  useEffect(() => {
    talkingRef.current = talking;
  }, [talking]);

  useEffect(() => {
    currentNPCRef.current = currentNPC;
  }, [currentNPC]);

  useEffect(() => {
    receiverRef.current = receiver;
    const aiEntity = getAIEntity(receiverRef.current);
    const npcComponent = getNpcComponent(aiEntity);
    setCurrentNPC(npcComponent);
  }, [receiver]);

  const update = useCallback(
    level => {
      // setLevel(level * 2);
    },
    [isRecording]
  );

  useVolumeMeter({
    analyser: scene.systems["hubs-systems"].audioSystem.outboundAnalyser,
    update
  });

  useEffect(() => {
    onListening(recording);
  }, [isRecording]);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
      <Button
        style={{ backgroundColor: "#16181E" }}
        appearance="subtle"
        icon={micActive ? <MicFilled /> : <MicOffFilled color="red" />}
        onClick={toggleMicActive}
      />
      <Button
        style={{ backgroundColor: "#16181E" }}
        appearance="subtle"
        icon={<DismissFilled />}
        onClick={swapToKeyboard}
      />
    </div>
  );
}

export function RecordButtonInput({ recording, setRecording }) {
  return (
    <div className={styles.recordButton} onClick={recording ? () => setRecording(false) : () => setRecording(true)}>
      <RecordIcon />
    </div>
  );
}
